<template>
  <div>
    <WizardTempWifiConnectStep
      v-if="wizardStep === 1"
      :handleNextStep="onNextStepClick"
      :isUpdate="true"
    />
    <WizardTempDeviceRegistStep
      v-if="wizardStep === 2"
      :handleNextStep="onNextStepClick"
      :serial="serialCode"
    />
    <WizardTempRegistCompleteStep
      v-if="wizardStep === 3"
      :handleNextStep="onNextStepClick"
    />
  </div>
</template>

<script setup>
import {
  ref,
  getCurrentInstance,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  reactive,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Axios, { ZoneApi, GroupApi, CtrlApi } from '@/api';
import { DeviceDefault, SettingConfig } from '@/common/constants';
import useMobile from '@/common/hooks/useMobile';
import useMqttControl from '@/common/hooks/useMqttControl';
import WizardTempWifiConnectStep from './components/wizard/WizardTempWifiConnectStep';
import WizardTempDeviceRegistStep from './components/wizard/WizardTempDeviceRegistStep';
import WizardTempRegistCompleteStep from './components/wizard/WizardTempRegistCompleteStep';

const { emitter, mobile, mqtt } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const router = useRouter();
const route = useRoute();
const {
  getWifiInfo,
  connectWifi,
  settingController,
  getControllerInfo,
  requestTransferController,
  requestRegistController,
  disConnectWifi
} = useMobile();

const wizardStep = ref(1);
const serialCode = ref('');
const account = computed(() => store.getters['account']);

// 컨트롤러 이관 :
let intervalId = null;

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
});

const onReceive = async (connectedController) => {
  return new Promise((resolve, reject) => {
    let requestCount = 0;
    
    // 기존 타이머 정리
    if (intervalId) {
      clearInterval(intervalId);
    }
    
    intervalId = setInterval(async () => {
      emitter.emit('setLoadingText', requestCount == 0 ? '조명제어기의 등록 여부를 확인하고 있습니다.' : `조명제어기의 등록 여부 확인을 ${requestCount + 1}번째 시도하고 있습니다.`);
      
      requestCount++;
      
      const result = await getControllerInfo(connectedController);
      if (result.resultCode) {
        clearInterval(intervalId);
        intervalId = null;
        resolve(result);
        return;
      }

      if (requestCount >= SettingConfig.requestCount) {
        clearInterval(intervalId);
        intervalId = null;
        reject('컨트롤러 이관에 실패했습니다.');
      }
    }, SettingConfig.requestInterval);
  });
};

const onNextStepClick = async (params) => {
  try {
    if (wizardStep.value === 1) {
      serialCode.value = params.serialCode;
      const controllerId = serialCode.value.slice(0, serialCode.value.indexOf("-"));

      const connectedController = {
        _id: controllerId,
        // model에 QR 시리얼을 넣지 않음 (서버/MQTT Version의 T0x 사용)
        version: 1,
      };

      emitter.emit('showLoading');
      const result = await onReceive(connectedController);
      console.log("result:", result)

      if (result.resultData?.length > 0) {
        emitter.emit('hideLoading');

        // 이미 등록된 컨트롤러일때 이관
        try {
          emitter.emit('setLoadingText', '온도조절기를 이관받고 있습니다.');
          const transResult = await requestTransferController(
            connectedController,
            account.value._id,
          );
          console.log("transResult:", transResult)

          if (transResult?.resultCode != "0000") {
            emitter.emit('showPopAlert', {
              description: transResult.resultMessage
            });
            return;
          }
        } catch(e) {
          emitter.emit('showPopAlert', {
            description: e
          });
          return;
        }
      } else {
        emitter.emit('hideLoading');
        emitter.emit('showPopAlert', {
          description: '등록되지 않은 온도조절기입니다.\n온도조절기를 등록합니다.',
          okCallback: () => wizardStep.value += 1,
          cancelCallback: () => wizardStep.value += 1,
        });
        return;
      }
      emitter.emit('hideLoading', true);
    
      await store.dispatch('home/fetchAllZones');

      emitter.emit('showPopAlert', {
        description: '이관받기가 완료되었습니다.',
        okCallback: () => router.go(-1),
        cancelCallback: () => router.go(-1),
      });
      return;
    } else if (wizardStep.value === 2) {
    } else if (wizardStep.value === 3) {
    } else {
      return;
    }

    wizardStep.value += 1;
  } catch (err) {
    console.log(err);
    if (err?.length > 0) {
      showPopAlert(err);
    }
  }
};

const showPopAlert = (msg) => {
  emitter.emit('showPopAlert', {
    description: msg,
  });
};
</script>